import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 10 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 19\" id=\"facebook\">\n    <path fill=\"#4A4A4A\" fill-rule=\"evenodd\" d=\"M9.74.842V3.64H8.074c-.608 0-1.018.127-1.23.381-.212.255-.318.636-.318 1.145v2.004h3.106L9.22 10.31H6.527v8.047H3.282V10.31H.58V7.17h2.703V4.86c0-1.315.368-2.334 1.103-3.059C5.12 1.077 6.099.714 7.322.714c1.04 0 1.845.043 2.417.128z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol